import {useNavigate} from "react-router-dom";
import {useUsername} from "../../../utils/utils";
import ApplicationCard from "../../ApplicationCard/ApplicationCard";
import {PktButton} from "@oslokommune/punkt-react";
import {PRIS_SØKNADER_ROUTE} from "../../../routes";
import React from "react";

export default function AktivResøknadCard() {
    const navigate = useNavigate()
    const userName = useUsername()
    return (
        <ApplicationCard title={userName ?? ""} variant={"gul"}>
            <div
                className={"pkt-txt-16-light"}>Vi har søkt om redusert barnehagepris for familien din for neste
                barnehageår.
            </div>
            <p
                className={"pkt-txt-16-light"}>På statussiden kan du også</p>
            <ul className={"pkt-txt-16-light mt-size-0"}>
                <li>laste opp ekstra dokumentasjon</li>
                <li>stoppe behandling av søknaden din</li>
            </ul>

            <PktButton onClick={() => navigate(PRIS_SØKNADER_ROUTE)} size={"small"}
                       className={"mt-size-16"}>
                Se status
            </PktButton>
        </ApplicationCard>
    )
}

